export default "__VITE_ASSET__myr6oER3__"